export const morphdomIgnoreAttributeName = "turboMorphIgnore"

export function morphdomIgnore(element, ignore) {
  if (ignore) {
    element.dataset.turboMorphIgnore = ''
  } else {
    delete element.dataset.turboMorphIgnore
  }
}

export function isMorphdomIgnored(element) {
  return morphdomIgnoreAttributeName in element.dataset
}
